import app, { Component } from 'apprun';
export default class OB_NewConversionComponent extends Component {
  state = {  };
  // prettier-ignore
  view = (state) => {
    if (!state) {return;}

    return (
      <div>
        <h1>  Coming soon.......  </h1>
        <div class="edit-buttons">
          <button class="btn btn-primary btn-xs pull-right" onclick={() => this.run('cancel')} >Cancel</button>
        </div>
      </div>
    );
  }

  update = {
    cancel: (state) => {
      app.run('#clear-panel', state.panelId);
    }
  };

}
